export enum UserLoginAccessDecision{
    APPROVED, //User and company same
    DENIED, //User and company not same / User tries to login on aphelia.io and company not found
    CALL_LOGIN_FUNCTION_AGAIN//User tries to login on aphelia.io, company found and redirecting to that company
}